import 'nouislider/distribute/nouislider.min';

'use strict';

var ad_slider = function () {
  var self = this;

  self.init();
  self.bind();

};

ad_slider.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_slider');

  jQuery(document).arrive('.ad_slider', self.init_slider);

};

ad_slider.prototype.init = function () {
  var self = this;

  // console.log('init ad_slider');

  self.init_slider();

};

ad_slider.prototype.init_slider = function () {
  //var self = this;

  // if ( jQuery('.ad_slider').length ) {

    jQuery('.ad_slider').each(
      function (/*index*/) {
        var element = jQuery(this);

        if (element.hasClass('st_mounted') === false) {

          var step = parseInt(element.attr('data-step') );
          var start = parseInt(element.attr('data-start') );
          var decimals = parseInt(element.attr('data-decimals') );

          var range_min = parseInt( element.attr('data-range-min') );
          var range_max = parseInt( element.attr('data-range-max') );

          // debugger

          var sliderElement = element.find('.slider');


          sliderElement.noUiSlider({
            step: step,
            start: start,
            connect: 'lower',
            range: {
              min: range_min,
              max: range_max
            },
            serialization: {
                format: {
                    decimals: decimals
                }
            }
          });

          sliderElement.on('change', function(event, value) {

            var slide = jQuery(this);
            var parent = slide.closest('.ad_slider');
            var input = parent.find('.ad_slider_el_input');

            input.val(value);
          });

          element.addClass('st_mounted');

        }

      }
    );

  // }

};


jQuery( document ).ready(function() {

  window.ad_slider = new ad_slider();

});



